exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.paySchedule{width:100%;border-collapse:collapse}.paySchedule td{border:1px solid #ccc;padding:6px}.paySchedule tr.tb-td td{font-weight:700}td.textCenter{text-align:center}td.textRight{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78aa353e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lending/installmentCollection/dataTable.vue
// module id = 1587
// module chunks = 3